<template>
	<b-container class="mt-4 h-95">
		<b-row class="h-100">
			<b-col class="d-flex flex-column">
				<b-row>
					<b-col class="h3">Relatório de Absenteísmo</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form>
							<Fieldset
								legend="Filtros"
								:toggleable="true"
								class="px-3 pb-3"
								ref="fieldset"
							>
								<b-row>
									<b-col class="col-12 col-md-6">
										<label for="data_inicial"
											>Data inicial</label
										>
										<b-form-datepicker
											id="data_inicial"
											v-model="data_inicial"
											:state="
												!$v.data_inicial.$error
													? null
													: false
											"
											:max="data_final"
										></b-form-datepicker>
									</b-col>
									<b-col class="col-12 col-md-6">
										<label for="data_final"
											>Data final</label
										>
										<b-form-datepicker
											id="data_final"
											v-model="data_final"
											:state="
												!$v.data_final.$error
													? null
													: false
											"
											:min="data_inicial"
										></b-form-datepicker>
									</b-col>
								</b-row>
								<b-row v-show="tipo_relatorio === 'sintetico'">
									<b-col class="col-12 col-md-6">
										<b-form-group
											id="tipo-autorizacao-fg"
											label="Tipo de autorização"
											label-for="tipo-autorizacao"
										>
											<b-form-select
												id="tipo-autorizacao"
												name="tipo-autorizacao"
												v-model="tipoautorizacao"
											>
												<template v-slot:first>
													<b-form-select-option
														:value="null"
														>-- Selecione o tipo de
														autorização
														--</b-form-select-option
													>
												</template>
												<b-form-select-option
													v-for="tipoautorizacao in tiposautorizacoes"
													:key="tipoautorizacao.id"
													:value="tipoautorizacao"
													>{{
														tipoautorizacao.descricao
													}}</b-form-select-option
												>
											</b-form-select>
										</b-form-group>
									</b-col>
									<b-col class="col-12 col-md-6">
										<b-form-group
											id="tipo-refeicao-fg"
											label="Tipo de refeição"
											label-for="tipo-refeicao"
										>
											<b-form-select
												id="tipo-refeicao"
												name="tipo-refeicao"
												v-model="tiporefeicao"
											>
												<template v-slot:first>
													<b-form-select-option
														:value="null"
														>-- Selecione o tipo de
														refeição
														--</b-form-select-option
													>
												</template>
												<b-form-select-option
													v-for="tiporefeicao in tiposrefeicoes"
													:key="tiporefeicao.id"
													:value="tiporefeicao"
													>{{
														tiporefeicao.descricao
													}}</b-form-select-option
												>
											</b-form-select>
										</b-form-group>
									</b-col>
								</b-row>
								<b-row v-show="tipo_relatorio == 'detalhado'">
									<b-col>
										<label for="input-profissional"
											>Profissional</label
										>
										<auto-complete
											v-model="profissionalSelecionado"
											:suggestions="
												profissionaisFiltrados
											"
											@complete="
												procuraProfissionais($event)
											"
											:minLength="3"
											field="nome"
											id="input-profissional"
											class="p-invalid"
										>
											<template #item="pessoa">
												<b-container
													fluid
													class="
														d-flex
														justify-content-between
													"
												>
													<div>
														{{ pessoa.item.nome }}
													</div>
													<div>
														{{ pessoa.item.cpf }}
													</div>
												</b-container>
											</template>
										</auto-complete>
									</b-col>
								</b-row>
								<b-row>
									<b-col>
										<b-form-group
											label="Tipo de relatório"
											v-slot="{ ariaDescribedby }"
										>
											<b-form-radio-group
												v-model="tipo_relatorio"
												:aria-describedby="
													ariaDescribedby
												"
												name="tipo-relatorio"
											>
												<b-form-radio
													:aria-describedby="
														ariaDescribedby
													"
													name="tipo-relatorio"
													value="sintetico"
													>Sintético</b-form-radio
												>
												<b-form-radio
													:aria-describedby="
														ariaDescribedby
													"
													name="tipo-relatorio"
													value="detalhado"
													>Detalhado</b-form-radio
												>
											</b-form-radio-group>
										</b-form-group>
									</b-col>
								</b-row>
							</Fieldset>
							<b-row class="mt-2">
								<b-col>
									<b-button
										variant="success"
										@click="geraRelatorio"
										:disabled="is_loading"										
										>
											<span class="spinner-border spinner-border-sm" v-if="is_loading"></span>
											<span v-if="is_loading"> Gerando...</span>
											<!-- <b-icon icon="spinner-border"  v-if="is_loading">												 -->
											<!-- </b-icon> -->
											<span v-else>Gerar relatório</span>											
										</b-button
									>
								</b-col>
							</b-row>
						</b-form>
					</b-col>
				</b-row>

				<b-row
					class="mt-2 flex-grow-1 h-100"
					v-show="!is_loading"
				>
					<b-col>
						<embed
							:src="src"
							width="100%"
							type="application/pdf"
							height="100%"
						/>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import Fieldset from "primevue/fieldset";
import { required, requiredIf } from "vuelidate/lib/validators";
import AutoComplete from "primevue/autocomplete";

export default {
	data() {
		return {
			src: "",
			data_inicial: null,
			is_loading: false,
			data_final: null,
			isDisplayingReport: false,
			tipo_relatorio: "sintetico",
			profissionaisFiltrados: null,
			profissionalSelecionado: null,
			tiporefeicao: null,
			tiposrefeicoes: null,
			tipoautorizacao: null,
			tiposautorizacoes: null,
		};
	},
	components: {
		Fieldset,
		AutoComplete,
	},
	methods: {
		geraRelatorio() {			
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$refs.fieldset.toggle();
				this.is_loading = true;
				this.$http({
					url: `/absenteismo?data_inicial=${
						this.data_inicial
					}&data_final=${this.data_final}&cpf=${
						this.profissionalSelecionado
							? this.profissionalSelecionado.cpf
							: null
					}&tipo_relatorio=${this.tipo_relatorio}&tiporefeicao=${
						this.tiporefeicao ? this.tiporefeicao.id : null
					}&tipoautorizacao=${
						this.tipoautorizacao
							? this.tipoautorizacao.descricao
							: null
					}`,
					responseType: "blob",
				})
					.then((response) => {
						var blob = new Blob([response.data], {
							type: "application/pdf",
						});
						var url = window.URL.createObjectURL(blob);
						this.src = url;
						this.is_loading = false;
					})
					.catch((e) => {						
						console.log(e);
						alert(
							e.message
						);
						this.is_loading = false;
					});

				this.isDisplayingReport = true;
			}
		},
		procuraProfissionais(event) {
			this.$http
				.get("/pessoaspornome/" + event.query.toLowerCase() + "?historico=true")
				.then((result) => {
					console.log("profissionais", result.data);
					this.profissionaisFiltrados = result.data;
					//console.log(result.data);
				});
		},
		getTiposAutorizacoes() {
			this.$http.get("/tipoautorizacao").then((response) => {
				// nessa view, o tipo de autorização vai ser alterado para excluir a 0 e a 1, de acompanhantes e a 5 da casa da gestante
				this.tiposautorizacoes = response.data;
			});
		},
		getTiposRefeicoes() {
			this.$http.get("/tipoderefeicao").then((response) => {
				this.tiposrefeicoes = response.data;
			});
		},
	},
	validations: {
		data_inicial: {
			required,
		},
		data_final: {
			required,
		},
		profissionalSelecionado: {
			required: requiredIf((e) => {
				return e.tipo_relatorio === "detalhado";
			}),
		},
	},
	mounted() {
		this.getTiposAutorizacoes();
		this.getTiposRefeicoes();
	},
};
</script>

<style strict>
.p-fieldset-legend {
	width: auto !important;
	font-size: 1rem !important;
}
.h-90 {
	height: 90%;
}
.h-95 {
	height: 95%;
}
</style>
